<template>
	<row-object-page name="folder_mapping_edit" :oref="oref" v-model="foldermappings" ref="rowObject"></row-object-page>
</template>

<script setup lang="ts">
import {ref, onBeforeMount, watch, reactive, computed} from "vue";
import RowObjectPage from "@/pages/row-object/RowObjectPage.vue";
import {objectRef, RowObjectInit, RowObjectRef, RowObjectType, SrcType} from "@t/meta/SourceType.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import type {FolderMappings} from "@t/mail/FolderMappings.ts";
import {connectEventBus, injectEnv} from "@fd/Environment.ts";
import {useListStore, ListId} from "@/store/ListStore.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";
import {CREATE, EDIT, REPLACE_INIT_WITH_EDIT} from "@/pages/row-object/RowObjectEvents.ts";

const ns = useNavigationStore();
const env = injectEnv();
const ls = useListStore();
const bus = connectEventBus("FolderMappingsPage");

const foldermappings = ref<FolderMappings>(null);
const rowObject = ref<InstanceType<typeof RowObjectPage> | null>(null);

const route = useVirtualRoute();
const oref = objectRef(route, SrcType.FOLDERMAPPINGS);

ns.listenForStackerUpdates(bus, oref, () => env.msg('menu.editIMAPFolders'),
	null, () => env.msg('menu.editIMAPFolders'), () => foldermappings.value.account);

onBeforeMount(() => {
	ls.installList("folderList", [{ value: "", name: "-" }]);
});

watch(() => foldermappings.value, (n, o) => {
	let listId = {
		serverId: "com.anneca.intouch.list.MailFoldersList[account="+foldermappings.value.account+"]",
		cacheId: "folderList",
		forceLoad: true
	};
    ls.findList(listId);
});

</script>

<style>
</style>